import { render, staticRenderFns } from "./BusinessSettings.vue?vue&type=template&id=b1aa1032&scoped=true"
import script from "./BusinessSettings.vue?vue&type=script&lang=js"
export * from "./BusinessSettings.vue?vue&type=script&lang=js"
import style0 from "./BusinessSettings.vue?vue&type=style&index=0&id=b1aa1032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aa1032",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg,QBtn,QInput,QSelect,QDialog,QCard});
